import { css } from '@emotion/react'
import { Heading, HFlow } from 'bold-ui'
import { Divider } from 'components/divider/Divider'

export const LoginSeparator = () => (
  <HFlow hSpacing={0.5} alignItems='center' style={styles.hFlow}>
    <Divider />

    <Heading level={4} style={styles.heading}>
      Ou
    </Heading>

    <Divider />
  </HFlow>
)

const styles = {
  hFlow: css`
    grid-auto-columns: 1fr auto 1fr;
  `,
  heading: css`
    font-weight: 400;
  `,
}
